<header [ngClass]="{'scrolled': scroll, 'secundary': initial}" class="fixed-top">
  <div class="container">
    <div class="row">
      <div class="col-md-6 col-6">
        <div class="logo">
          <img (click)='home()' src="assets/img/verifica/logo.svg" height="60" alt="Midatacrédito | Verifica">
        </div>
      </div>
      <div class="col-md-6 col-6">
        <div class="links">
          <div class="logDesktop">
            @if (!sesionv.sesionCookiev) {
              <a class="inicio" [href]="loginUrl" rel="noopenner nofollow">Inicia Sesión</a>
            }
            @if (!sesionv.sesionCookiev) {
              <a [href]="regUrl" rel="noopenner nofollow">Regístrate <i class="fa fa-angle-right" aria-hidden="true"></i></a>
            }
            <div class="accordion" id="faqAccordion">
              <div class="card-header despliega" id="faq1">
                @if (sesionv.sesionCookiev) {
                  <button class="loggeado" (click)="toggleClass()" type="button" data-toggle="collapse" data-target="#navbarSupportedContent20" aria-controls="navbarSupportedContent20" aria-expanded="false" aria-label="Toggle navigation">
                    <div [class.open]="isOpen" class="animated-icon">Hola, {{sesionv.userv?.nombre}} {{sesionv.userv?.apellido}}</div>
                  </button>
                }
              </div>
              @if (isOpen) {
                <div class="collapse">
                  <a class="menuLoggeado" routerLink="/historico" (click)="toggleClass()"><span>Consultas</span></a><br />
                  <a class="menuLoggeado" (click)="cerrarSession()"><span>Salir</span></a>
                </div>
              }
            </div>
          </div>
          <div class="logMobile">
            @if (!sesionv.sesionCookiev) {
              <div>
                <button (click)="toggleClass()" type="button" data-toggle="logMobileInto" aria-expanded="false">
                  <div [class.open]="isOpen" class="hamburguer"></div>
                </button>
              </div>
            }
            @if (isOpen) {
              <div class="logMobileInto" id="navbarNavUser">
                <a class="menuMobile" [href]="loginUrl" rel="noopenner nofollow">Inicia Sesión</a>
                <a class="menuMobile" [href]="regUrl" rel="noopenner nofollow">Regístrate</a>
              </div>
            }
            @if (sesionv.sesionCookiev) {
              <div>
                <button (click)="toggleClass2()" type="button" data-toggle="menuMobileInto" aria-expanded="false" class="loggeadoMobile">
                  <div [class.open]="isOpen2">{{sesionv.userv?.nombre}} {{sesionv.userv?.apellido}}</div>
                </button>
              </div>
            }
            @if (isOpen2) {
              <div class="menuMobileInto" id="navbarNavUser2">
                <a class="menuMobile" routerLink="/historico" (click)="toggleClass2()">Consultas</a>
                <a class="menuMobile" (click)="cerrarSession()">Salir</a>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</header>